import { WIDGETS_TYPE } from "@/enums/filter.enum";
import { ColumnFilter } from "./columnFilter";

export interface advancedFilterInterface {
  columns: Array<any>;
  schema: any;
  filterQuery: string;
}

export class AdvancedFilter implements advancedFilterInterface {
  columns: Array<any> = [];
  schema: any = null;
  filterQuery: string = "";
  constructor(data: any) {
    this.columns = data?.filter((item) => item?.advancedFilter).map((item) => new ColumnFilter(item.advancedFilter));
    this.filterQuery = this.getFilterQuery();
  }

  public getSpecialColumn(): any {
    return this.columns?.find((column) => column?.type === WIDGETS_TYPE.SPECIAL) || new ColumnFilter({});
  }

  public getFilterQuery(): string {
    let filterQuery = "";
    this.columns?.forEach((column) => {
      if (!column.getQuery()) return;
      filterQuery += column.getQuery() + "&";
    });
    if (filterQuery.slice(-1) === "&") filterQuery = filterQuery.slice(0, -1);
    return filterQuery;
  }

  public assignOptions(filterOption): void {
    this.columns.forEach((column) => {
      filterOption.forEach((option) => {
        console.log(option[column.name]);
        option[column.name] ? (column.options = option[column.name]) : (column.options = []);
      });
    });
  }
}
